import { useTranslation } from 'react-i18next';
import { TeContainer, TeGrid } from '@topcon/tuicl-react';

import { Section } from '../../utils/styling';
import Header from '../../components/Header';
import LandingCard from '../../components/LandingCard';
import { AppRoutes } from '../../app/routes/utils';

const Support = () => {
  const { t } = useTranslation('support');

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('support')} />
      <Section>
        <TeGrid gap="s">
          <LandingCard
            to={AppRoutes.Organizations}
            icon="corporate_fare"
            title={t('organizations.title')}
            description={t('organizations.description')}
            buttonText={t('organizations.manageOrganizations')}
          />
          <LandingCard
            to={AppRoutes.TopconId}
            icon="person"
            title={t('topconId.title')}
            description={t('topconId.description')}
            buttonText={t('topconId.supportTopconId')}
          />
        </TeGrid>
      </Section>
    </TeContainer>
  );
};

export default Support;
